import { useQuery } from "@tanstack/react-query";
import api from "../api";

export function nearbyQueryKey(category, latitude, longitude, radius, text, tagIds, includeDescription, eventDateFilter = "all") {
  return ["nearby", category, latitude, longitude, radius, text, [...tagIds].sort((a, b) => a - b).join(","), includeDescription, eventDateFilter];
}

async function fetchNearbyResults({ category, latitude, longitude, radius, text, tags, includeDescription, eventDateFilter }) {
  const response = await api.get(process.env.REACT_APP_NEARBY_URL, {
    params: {
      lat: latitude,
      lng: longitude,
      radius,
      limit: 50,
      type: category === "eventy" ? "events" : "places",
      text: text || undefined,
      tags: tags.length ? tags.map((tag) => tag.value).join(",") : undefined,
      includeDescription: includeDescription ? "1" : undefined,
      period: eventDateFilter,
    },
  });

  return response.data ?? {};
}

export function useNearbyQuery({ category, location, radius, text, tags, includeDescription, eventDateFilter, enabled }) {
  const tagIds = tags.map((tag) => tag.id);
  return useQuery({
    queryKey: nearbyQueryKey(category, location?.lat, location?.lng, radius, text, tagIds, includeDescription, eventDateFilter),
    queryFn: () => fetchNearbyResults({
      category,
      latitude: location.lat,
      longitude: location.lng,
      radius,
      text,
      tags,
      includeDescription,
      eventDateFilter,
    }),
    enabled,
    staleTime: 30_000,
  });
}
